import { useModal } from "@/hooks/modals/useModal";
import { useContractRecordQuery } from "./useContractRecordQuery";
import { useContractFlowNodeMatcher } from "./useContractFlowNodeMatcher";

export function useFormEditable() {
  const { props } = useModal("PURCHASE_CONTRACT");
  const { mode, viewStatus, isReadOnly, recordId } = props;

  const detail = useContractRecordQuery(recordId);

  const {
    isMatchSupplierContractUploadShouldApplyNode,
    isMatchConfirmContractNode,
    isMatchPendingSupplierUploadNode,
  } = useContractFlowNodeMatcher(detail?.insId);

  const isInReviewMode = mode === "inReview";
  const isStartedMode = mode === "started";

  // 满足下面条件时，主表单禁止编辑
  const mainFormDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && isMatchSupplierContractUploadShouldApplyNode !== true,
  ];

  // 满足下面条件时，合同基本信息禁止编辑
  const basicContractFormFieldsDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode,
  ];

  // 满足下面条件时，合同文件信息禁止编辑
  const contractFileFormFieldsDisabledRules = [
    isStartedMode,
    isInReviewMode && viewStatus === false,
    isInReviewMode && isMatchPendingSupplierUploadNode !== true,
  ];

  // 满足下面条件时，KMS合同文件编号禁止编辑
  const kmsContractFileNumberFormFieldsDisabledRules = [
    isStartedMode,
    isInReviewMode && viewStatus === false,
    isInReviewMode && isMatchConfirmContractNode !== true,
  ];

  return {
    isMainFormDisabled: mainFormDisabledRules.some((rule) => !!rule),
    isBasicContractFormFieldsDisabled:
      basicContractFormFieldsDisabledRules.some((rule) => !!rule),
    isContractFileFormFieldsDisabled: contractFileFormFieldsDisabledRules.some(
      (rule) => !!rule,
    ),
    isKmsContractFileNumberFormFieldsDisabled:
      kmsContractFileNumberFormFieldsDisabledRules.some((rule) => !!rule),
  };
}
